// Odoo API配置和工具函数

// Odoo服务器配置
const ODOO_CONFIG = {
    baseUrl: process.env.VUE_APP_API_BASE_URL || '',
    db: process.env.VUE_APP_ODOO_DB || 'odoo',
    username: process.env.VUE_APP_ODOO_USERNAME,
    password: process.env.VUE_APP_ODOO_PASSWORD
}

// 模型映射配置
const MODEL_MAPPING = {
    'tmys.order': 'tmys.order',
    'tmys.product.cloth': 'tmys.product.cloth',
    'tmys.product.material': 'tmys.product.material',
    'tmys.product.auxiliary': 'tmys.product.auxiliary',
    'tmys.product.equip': 'tmys.product.equip'
}

// 构建Odoo搜索域
export const buildOdooDomain = (category, query) => {
    const model = MODEL_MAPPING[category]
    if (!model) {
        throw new Error('无效的搜索类别！')
    }

    // 根据不同模型构建搜索条件
    let domain = []
    if (model === 'tmys.order') {
        domain = [
            '&',
            ['state', '=', '审核通过'],  // 添加审核通过的条件
            ['title', 'ilike', query]
        ]
    } else if (model === 'tmys.product.cloth') {
        domain = [
            '&',
            ['state', '=', '审核通过'],  // 添加审核通过的条件
            '|',
            ['name', 'ilike', query],
            ['description', 'ilike', query]
        ]
    } else if (model === 'tmys.product.material') {
        domain = [
            '&',
            ['state', '=', '审核通过'],  // 添加审核通过的条件
            '|',
            ['name', 'ilike', query],
            ['description', 'ilike', query],
        ]
    } else if (model === 'tmys.product.auxiliary') {
        domain = [
            '&',
            ['state', '=', '审核通过'],  // 添加审核通过的条件
            '|',
            ['name', 'ilike', query],
            ['description', 'ilike', query],
        ]
    } else if (model === 'tmys.product.equip') {
        domain = [
            '&',
            ['state', '=', '审核通过'],  // 添加审核通过的条件
            '|',
            ['name', 'ilike', query],
            ['description', 'ilike', query],
        ]
    }

    return domain
}

// 执行Odoo搜索
export const searchOdoo = async (category, query) => {
    try {
        console.log('category', category)
        const model = MODEL_MAPPING[category]
        if (!model) {
            throw new Error('无效的搜索类别')
        }

        const domain = buildOdooDomain(category, query)
        // 获取模型字段规格说明
        const getModelSpecification = (model) => {
            // 通用字段
            const commonFields = {
                state: {}
            }

            // 模型特定字段
            const modelFields = {
                'tmys.order': {
                    title: {},
                    id: {},

                    county_data_id: { fields: { display_name: {} } },
                    state: { fields: { display_name: {} } }
                },
                'tmys.product.cloth': {
                    public_cate_id: { fields: { display_name: {} } },
                    user_id: { fields: { display_name: {} } },
                    phone_no: {},
                    county_data_id: { fields: { display_name: {} } },
                    detail_addr: {},
                    description: {},
                    color: {},
                    size: {},
                    content_name: {},
                    process_name: {},
                    product_no: {},
                    style: {},
                    people: {},
                    year_season: {},
                    place: {},
                    price: {},
                    content: {},
                    age: {},
                    way: {},
                    name: {},

                },
                'tmys.product.material': {
                    public_cate_id: { fields: { display_name: {} } },
                    user_id: { fields: { display_name: {} } },
                    phone_no: {},
                    county_data_id: { fields: { display_name: {} } },
                    detail_addr: {},
                    color: {},
                    category: {},
                    content: {},
                    usage: {},
                    product_no: {},
                    weight: {},
                    width: {},
                    sample_price: {},
                    big_price: {},
                    stored_quantity: {},
                    stored_unit: { fields: { display_name: {} } },
                    name: {},

                },
                'tmys.product.auxiliary': {
                    public_cate_id: { fields: { display_name: {} } },
                    user_id: { fields: { display_name: {} } },
                    phone_no: {},
                    county_data_id: { fields: { display_name: {} } },
                    detail_addr: {},
                    color: {},

                    category: {},
                    content: {},
                    usage: {},
                    product_no: {},
                    weight: {},
                    width: {},
                    sample_price: {},
                    big_price: {},
                    stored_quantity: {},
                    stored_unit: { fields: { display_name: {} } },
                    name: {},

                },
                'tmys.product.equip': {
                    public_cate_id: { fields: { display_name: {} } },
                    user_id: { fields: { display_name: {} } },
                    phone_no: {},
                    county_data_id: { fields: { display_name: {} } },
                    detail_addr: {},

                    stored_quantity: {},
                    stored_unit: { fields: { display_name: {} } },
                    price: {},
                    name: {},

                }
            }

            return { ...commonFields, ...(modelFields[model] || {}) }
        }

        // 获取当前模型的字段规格说明
        const specification = getModelSpecification(model)

        const response = await fetch(`${ODOO_CONFIG.baseUrl}/web1/dataset/call_kw/${model}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'call',
                params: {
                    model: model,
                    method: 'web_search_read',
                    args: [],
                    kwargs: {
                        specification: specification,
                        offset: 0,
                        order: '',
                        limit: 80,
                        context: {
                            lang: 'zh_CN',
                            tz: 'Asia/Shanghai',
                            uid: 2,
                            allowed_company_ids: [1],
                            bin_size: true,
                            current_company_id: 1
                        },
                        count_limit: 10001,
                        domain: domain
                    }
                }
            })
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const result = await response.json()
        if (result.error) {
            throw new Error(result.error.data.message || '搜索失败')
        }

        return result.result.records
    } catch (error) {
        console.error('Odoo搜索失败:', error)
        throw error
    }
}